import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import "./about-us.css";
import { useAboutProfileModal } from "./useAboutProfileModal";
import {
  AboutSatishSection,
  AboutOversightSection,
  AboutLeadershipTeamSection,
  AboutCtaSection,
} from "./AboutSections";

const AboutTeam = () => {
  const { openProfileModal, profileModal } = useAboutProfileModal();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Our Team | AGCX Leadership & Management</title>
        <meta
          name="description"
          content="Meet the leadership team behind AGCX — experienced professionals in compliance, trading, and fintech driving a regulated crypto exchange in the UAE."
        />
        <meta
          name="keywords"
          content="AGCX leadership team, crypto exchange management UAE"
        />
        <link rel="canonical" href="https://arabglobal.ae/about_us/team" />
      </Helmet>

      <div className="agc_about_page_wrapper agc_about_page_wrapper--team">
        {/* Order: 1) Satish  2) Two Sheikhs  3) Remaining team */}
        <AboutSatishSection openProfileModal={openProfileModal} />
        <AboutOversightSection openProfileModal={openProfileModal} />
        <AboutLeadershipTeamSection openProfileModal={openProfileModal} />
        <AboutCtaSection />
      </div>

      {profileModal}
    </>
  );
};

export default AboutTeam;
